import Offcanvas from "react-bootstrap/Offcanvas";
import DocPlaceholder from '../assets/images/document-placeholder.jpg';
import { useEffect, useState } from "react";
import downloadIcon from '../assets/images/download.svg';

interface propData {
    data: any;
    isShow: boolean;
    isClose: any;
}

const EquipmentPreviewBlade = (props: propData) => {

    const onCloseModal = (e?: any) => {
        props.isClose(!props.isShow, e)
    };

    return (
        <>
            <Offcanvas
                show={props.isShow}
                onHide={onCloseModal}
                placement={"end"}
                className="offcanvas-large"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Equipment Preview</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="border-bottom px-0 information-main-view ">
                    <div className="px-3 form-style">
                        <div className="text-center mb-3 d-flex justify-content-end" >
                            <div className="download-button cursor-pointer" onClick={() => window.open(props?.data)}>
                                <img src={downloadIcon} height={22} className="me-2" />
                            </div>
                        </div>
                        <div className="d-flex">
                            <img src={props?.data ? props?.data : DocPlaceholder} alt="imag" className="image cursor-pointer" style={{ height: '80vh', width: '100%', objectFit: 'contain' }} />
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default EquipmentPreviewBlade;